// @ts-nocheck
/* Store Custom File */

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

/* Store Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
import { StyledImgWrapper } from "@store/MobiusOverrides/Img/Img";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";

const separatorStyles = () => css`
    &::before {
        display: block;
        content: "";
        position: relative;
        height: ${pxToRem(43)};
        width: ${pxToRem(1)};
        background-color: ${getColor("common.border")};
        left: -${pxToRem(10)};
    }
`;

const cellStyles = () => css`
    position: relative;
    padding: ${pxToRem(0, 20)};
    display: flex;
    align-items: center;
`;
/* Store Custom Code - End */

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    // Store Custom Code
    linkList: InjectableCss;
    signIn: InjectableCss;
    cart: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    /* Store Custom Code - Start */
    container: {
        css: css`
            ${siteWidthStyles()}

            ${breakpoint("lg")} {
                padding: ${pxToRem(16, 15, 0)};
                display: flex;
                justify-content: space-between;
                position: relative;
            }
        `,
    },
    logoWrapper: {
        css: css`
            ${cellStyles()}
            padding-bottom:  ${pxToRem(15)};
            padding-left: 0;
            img {
                height: ${pxToRem(70)};
                width: ${pxToRem(192)};
                margin: 0;
            }

            ${StyledImgWrapper} {
                background: transparent !important;
            }
        `,
    },
    searchMenuWrapper: {
        css: css`
            ${cellStyles()}
            flex-grow: 1;
            padding-left: ${pxToRem(40)};
        `,
    },
    linkListHidden: {},
    linkList: {
        css: css`
            ${cellStyles()}
            a,
            a span,
            button {
                color: ${getColor("neutral.contrast")};

                &:hover {
                    color: ${getColor("neutral.contrast")};
                    text-decoration: underline;
                }
            }
        `,
    },
    signIn: {
        css: css`
            ${separatorStyles()}
            ${cellStyles()}
			line-height:1;
        `,
    },
    cart: {
        css: css`
            ${separatorStyles()}
            ${cellStyles()}
			${breakpoint("sm")} {
                padding-right: 0;
            }
        `,
    },
    /* Store Custom Code - End */
};

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => (
    <Hidden below="lg">
        {/* Store Custom Code - Start */}
        <StyledWrapper {...logoLinksSearchStyles.container}>
            <StyledWrapper {...logoLinksSearchStyles.logoWrapper}>
                <Zone contentId={id} zoneName="Logo" />
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.searchMenuWrapper}>
                <Zone contentId={id} zoneName="Search" />
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.linkList}>
                <Zone contentId={id} zoneName="LinkList" />
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.signIn}>
                <Zone contentId={id} zoneName="SignIn" />
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.cart}>
                <Zone contentId={id} zoneName="Cart" />
            </StyledWrapper>
        </StyledWrapper>
        {/* Store Custom Code - End */}
    </Hidden>
);

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
        allowedContexts: ["Header"], // Store Custom Code
    },
};

export default logoLinksSearch;
